"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToBaseProgram = exports.mapToArticle = exports.mapToArticleWithRelations = void 0;
const constants_1 = require("../constants");
const models_1 = require("../models");
const removeEmpty_1 = require("./removeEmpty");
const mapToArticleWithRelations = (objectData, options = { update: false, removeEmpty: false }) => {
    const { update, removeEmpty } = options;
    if (removeEmpty) {
        return removeEmptyProps(mapToArticleWithRelationsFn(objectData, update));
    }
    return mapToArticleWithRelationsFn(objectData, update);
};
exports.mapToArticleWithRelations = mapToArticleWithRelations;
const mapToArticleWithRelationsFn = (objectData, update) => {
    var _a;
    if (objectData.program) {
        const program = mapToPartialArticle(objectData);
        let articles = [];
        if (objectData.program.sessions) {
            const sessions = objectData.program.sessions.map((session) => {
                // Only update duration and equipment for upcoming sessions
                if (update && session.state !== models_1.SessionState.Waiting) {
                    return mapToPartialArticle({
                        session: Object.assign(Object.assign({}, session), { program: Object.assign(Object.assign({}, objectData.program), { duration: null, equipment: null }) }),
                    });
                }
                return mapToSessionArticle(Object.assign(Object.assign({}, session), { program: objectData.program }));
            });
            articles = [...articles, ...sessions];
        }
        if ((_a = objectData.program.instructor) === null || _a === void 0 ? void 0 : _a.programs) {
            const instructor = mapToInstructorArticle(objectData.program.instructor);
            articles.push(instructor);
        }
        if (articles.length > 0) {
            articles.push(program);
            return articles;
        }
        else {
            return program;
        }
    }
    if (objectData.instructor) {
        const instructor = mapToInstructorArticle(objectData.instructor);
        if (objectData.instructor.programs) {
            const articles = objectData.instructor.programs.reduce((prev, curr) => {
                const program = Object.assign(Object.assign({}, curr), { instructor: objectData.instructor });
                const sessions = program.sessions.map((session) => mapToSessionArticle(Object.assign(Object.assign({}, session), { program })));
                const programArticle = mapToProgramArticle(program);
                return [...prev, ...sessions, programArticle];
            }, []);
            if (articles.length > 0) {
                articles.push(instructor);
                return articles;
            }
        }
        return instructor;
    }
    if (objectData.basicInstructor) {
        const basicInstructor = mapToBasicInstructorArticle(objectData.basicInstructor);
        return basicInstructor;
    }
    if (objectData.session) {
        return mapToSessionArticle(objectData.session);
    }
};
const mapToArticle = (objectData) => {
    if (objectData.program) {
        return mapToProgramArticle(objectData.program);
    }
    if (objectData.session) {
        return mapToSessionArticle(objectData.session);
    }
    if (objectData.instructor) {
        return mapToInstructorArticle(objectData.instructor);
    }
    if (objectData.basicInstructor) {
        return mapToBasicInstructorArticle(objectData.basicInstructor);
    }
};
exports.mapToArticle = mapToArticle;
const mapToProgramArticle = (program) => {
    const bookedUsersSummary = getBookedUsersSummaryFromProgram(program);
    const popularityScore = program.statistic
        ? program.statistic.attended + bookedUsersSummary.total
        : null;
    return Object.assign({ type: models_1.ArticleType.PROGRAM, objectID: `${models_1.ArticleType.PROGRAM}_${program.id}`, id: program.id, bookedUsersSummary,
        popularityScore, requiredProduct: program.requiredProduct }, mapToBaseProgramProperties(program));
};
const mapToBaseProgram = (program) => {
    var _a, _b, _c, _d;
    return {
        id: program.id,
        categories: (_a = program.categories) === null || _a === void 0 ? void 0 : _a.map((category) => category.title),
        duration: program.duration,
        imageUrl: program.imageUrl,
        instructorId: (_b = program.instructor) === null || _b === void 0 ? void 0 : _b.id,
        instructorName: `${program.instructor.name.first} ${program.instructor.name.last}`,
        level: program.level,
        rating: program.rating,
        tags: program.programTags.map((tag) => tag.title),
        title: program.title,
        equipment: program.equipment,
        focus: program.focus,
        partnerTitle: (_d = (_c = program.instructor) === null || _c === void 0 ? void 0 : _c.partnerProfile) === null || _d === void 0 ? void 0 : _d.title,
        requiredProduct: program.requiredProduct,
        deletedAt: !!program.deletedAt,
    };
};
exports.mapToBaseProgram = mapToBaseProgram;
const mapToBaseProgramProperties = (program) => {
    const _a = (0, exports.mapToBaseProgram)(program), { id, requiredProduct } = _a, baseProps = __rest(_a, ["id", "requiredProduct"]);
    return Object.assign(Object.assign({}, baseProps), { programId: id });
};
const mapToSessionArticle = (session) => {
    var _a, _b, _c;
    if (session.state === models_1.SessionState.Finished &&
        (session.mp4Url || session.hlsUrl)) {
        return Object.assign(Object.assign({}, (session.program ? mapToBaseProgramProperties(session.program) : {})), { type: models_1.ArticleType.ANYTIME, objectID: `${models_1.ArticleType.SESSION}_${session.id}`, id: session.id, hlsUrl: session.hlsUrl, mp4Url: session.mp4Url, startTimestamp: new Date(session.start).getTime(), endTimestamp: new Date(session.end).getTime(), thumbnailUrl: session.thumbnailUrl, title: session.program ? session.program.title : '', popularityScore: (_a = session.statistic) === null || _a === void 0 ? void 0 : _a.attended, requiredProductLive: session.requiredProductLive, requiredProductAnytime: session.requiredProductAnytime, deletedAt: !!session.deletedAt });
    }
    return Object.assign(Object.assign({}, (session.program ? mapToBaseProgramProperties(session.program) : {})), { type: models_1.ArticleType.SESSION, objectID: `${models_1.ArticleType.SESSION}_${session.id}`, id: session.id, startTimestamp: new Date(session.start).getTime(), endTimestamp: new Date(session.end).getTime(), bookedUsersSummary: session.bookedUsersSummary || getBookedUsersSummaryFromSession(session), title: session.program ? session.program.title : '', popularityScore: ((_b = session.bookedUsersSummary) === null || _b === void 0 ? void 0 : _b.total) >= 0 || ((_c = session.bookedUsers) === null || _c === void 0 ? void 0 : _c.length), state: session.state, requiredProductLive: session.requiredProductLive, requiredProductAnytime: session.requiredProductAnytime, deletedAt: !!session.deletedAt });
};
const mapToInstructorArticle = (instructor) => {
    var _a, _b, _c, _d;
    const programs = [];
    const ratings = [];
    const categories = [];
    const tags = [];
    if (instructor.programs) {
        for (const program of instructor.programs) {
            programs.push(program.title);
            ratings.push(program.rating);
            program.categories.forEach(({ title }) => {
                if (!categories.includes(title)) {
                    categories.push(title);
                }
            });
            program.programTags.forEach(({ title }) => {
                if (!tags.includes(title)) {
                    tags.push(title);
                }
            });
        }
    }
    return {
        type: models_1.ArticleType.INSTRUCTOR,
        objectID: `${models_1.ArticleType.INSTRUCTOR}_${instructor.id}`,
        id: instructor.id,
        imageUrl: instructor.imageUrl,
        programs,
        title: `${instructor.name.first} ${instructor.name.last}`,
        description: (_a = instructor.instructorProfile) === null || _a === void 0 ? void 0 : _a.title,
        popularityScore: ((_c = (_b = instructor === null || instructor === void 0 ? void 0 : instructor.instructorProfile) === null || _b === void 0 ? void 0 : _b.followers) === null || _c === void 0 ? void 0 : _c.length) || 0,
        categories,
        tags,
        partnerTitle: (_d = instructor === null || instructor === void 0 ? void 0 : instructor.partnerProfile) === null || _d === void 0 ? void 0 : _d.title,
    };
};
const mapToBasicInstructorArticle = (basicInstructor) => {
    var _a, _b, _c, _d;
    const tags = [`${basicInstructor.name.first} ${basicInstructor.name.last}`];
    return {
        type: models_1.ArticleType.BASIC_INSTRUCTOR,
        objectID: `${models_1.ArticleType.BASIC_INSTRUCTOR}_${basicInstructor.id}`,
        id: basicInstructor.id,
        imageUrl: basicInstructor.imageUrl,
        title: ((_a = basicInstructor.name) === null || _a === void 0 ? void 0 : _a.custom) ||
            `${basicInstructor.name.first} ${basicInstructor.name.last}`,
        description: (_b = basicInstructor.instructorProfile) === null || _b === void 0 ? void 0 : _b.title,
        popularityScore: ((_d = (_c = basicInstructor === null || basicInstructor === void 0 ? void 0 : basicInstructor.instructorProfile) === null || _c === void 0 ? void 0 : _c.followers) === null || _d === void 0 ? void 0 : _d.length) || 0,
        tags,
    };
};
const getBookedUsersSummaryFromSession = (session) => {
    if (!session.bookedUsers) {
        return null;
    }
    const total = session.bookedUsers.length;
    const highlighted = session.bookedUsers
        .slice(-constants_1.KvixConstants.CARD_MAX_HIGHLIGHTED_USERS)
        .map((user) => user.imageUrl);
    return {
        highlighted,
        total,
    };
};
const getBookedUsersSummaryFromProgram = (program) => {
    if (!program.sessions) {
        return null;
    }
    const noBookedUsers = program.sessions.find((session) => !session.bookedUsers);
    if (noBookedUsers) {
        return null;
    }
    const bookedUsers = program.sessions.reduce((prev, curr) => [
        ...prev,
        ...curr.bookedUsers,
    ], []);
    const highlighted = bookedUsers
        .slice(-constants_1.KvixConstants.CARD_MAX_HIGHLIGHTED_USERS)
        .map((user) => user.imageUrl);
    return {
        total: bookedUsers.length,
        highlighted,
    };
};
const mapToPartialArticle = (objectData) => {
    const article = (0, exports.mapToArticle)(objectData);
    const partialArticle = removeEmptyProps(article);
    return partialArticle;
};
const removeEmptyProps = (object) => {
    if (object instanceof Array) {
        return object.map(removeEmpty_1.removeEmptyValues);
    }
    return (0, removeEmpty_1.removeEmptyValues)(object);
};
//# sourceMappingURL=mapToArticle.js.map